



















































































































import { Component } from 'vue-property-decorator';
import { Action } from 'vuex-class';
import Vue from 'vue';

import { ActionTypes } from '@/modules/neopvc/store/types';
import { Project, tabs } from '@/modules/neopvc/models';
import { MessageService } from '@/services/messageService';

@Component({})
export default class extends Vue {
  @Action(ActionTypes.UPDATE_CURRENT_TAB)
  public updateCurrentTab: (tab: string) => void;

  @Action(ActionTypes.UPDATE_NEW_PROJECT)
  public updateNewProject: (newProject: boolean) => void;

  @Action(ActionTypes.SAVE_NEW_PROJECT)
  public saveNewProject: (project: Project) => Promise<void>;

  public project: Project | any = {
    id: 0,
    name: '',
    distributioninitial: '',
    distributionend: '',
    referencedate: '',
    createat: '',

    indexNeighborhoodOriginalShare: 0.35,
    indexNeighborhoodDemographicShare: 0.5,
    indexNeighborhoodOutletShare: 0.07,
    indexNeighborhoodDistanceShare: 0.08,

    originalsharecutting: 0.47,
    originalshareindex: 0.7,
    demographicindex: 0.3,
  };

  public valid = false;

  public formatIndex(value: number) {
    return (value * 100).toFixed(0);
  }

  public get projectFormatted() {
    return {
      ...this.project,

      indexNeighborhoodOriginalShare: this.formatIndex(this.project.indexNeighborhoodOriginalShare),
      indexNeighborhoodDemographicShare: this.formatIndex(this.project.indexNeighborhoodDemographicShare),
      indexNeighborhoodOutletShare: this.formatIndex(this.project.indexNeighborhoodOutletShare),
      indexNeighborhoodDistanceShare: this.formatIndex(this.project.indexNeighborhoodDistanceShare),

      originalshareindex: this.formatIndex(this.project.originalshareindex),
      originalsharecutting: this.formatIndex(this.project.originalsharecutting),
      demographicindex: this.formatIndex(this.project.demographicindex),
    };
  }

  public async onSaveProject() {
    this.project = {
      ...this.project,
      distributioninitial: this.toDateISOString(this.project.distributioninitial),
      distributionend: this.toDateISOString(this.project.distributionend),
      referencedate: this.toDateISOString(this.project.referencedate),
    };

    try {
      await this.saveNewProject(this.project);

      MessageService.Success(
        'Sucesso',
        'Operação realizada com sucesso.',
        'center',
      );

      this.redirectToList();
    } catch (error) {
      MessageService.Error(
        'Error',
        'Operação não foi realizada. Contacte o suporte.',
        'center',
      );
    }
  }

  public onCancel() {
    this.redirectToList();
  }

  public indexRules(target: string) {
    return [
      (v: any) => !!v || `${target} é obrigatório`,
      (v: any) => this.formatNumber(v) >= 0 || `${target} deve ser maior ou igual que 0`,
      (v: any) => this.formatNumber(v) <= 1 || `${target} deve ser menor ou igual a 100`,
    ];
  }

  public dateDistributionRules(target: string) {
    return [(v: any) => !!v || `${target} é obrigatório`];
  }

  public setInputNumber(value: string, target: string) {
    if (value === '') {
      this.project[target] = 0;
    }

    this.project[target] = this.formatNumber(value);
  }

  private formatNumber(value: string, fixed: number = 2) {
    return (parseFloat(value) / 100);
  }

  private redirectToList() {
    this.$router.push('/neopvc/project');
    this.updateCurrentTab(tabs.list);
    this.updateNewProject(false);
  }

  private toDateISOString(date: string) {
    return new Date(date).toISOString();
  }
}
